<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
    </base-header>
    <b-container fluid class="mt--7">
    <card>
      <p v-if="isLoading">Loading...</p>
      <template v-else>
        <b-row>
          <b-col>
            <h4>Job group log ID:</h4>
            <p>{{jobGroupLog.id}}</p>
          </b-col>
          <b-col>
            <h4>Job group name:</h4>
            <p>{{jobGroupLog.job_group}}</p>
          </b-col>
          <b-col>
            <h4>Start time:</h4>
            <p>{{formatDefaultDate(timestampToDatetime(jobGroupLog.start_time))}}</p>
          </b-col>
          <b-col>
            <button class="btn btn-success" @click="downloadResults()">
              <template v-if="!isDownloading">Download</template>
              <template v-else>Downloading...</template> <!-- TODO: Alttaki ikonun animasyonunu düzelt ve onu kullan -->
              <!-- <b-icon v-else icon="arrow-clockwise" animation="spin" font-scale="2"></b-icon> -->
            </button>
          </b-col>
        </b-row>
        <b-row>
          
        </b-row>
      </template>
      <job-history-table :jobGroupId="id" />
    </card>
    </b-container>
  </div>
</template>

<script>
import JobHistoryTable from '@/views/Tables/JobHistoryTable.vue';

import RepositoryFactory from '@/repositories/RepositoryFactory'

const JobGroupLogRepository = RepositoryFactory.get('job_group_log')
const LocationRepository = RepositoryFactory.get('location')

export default {
    name:'job-history-detail',
    props:{
        id:Number
    },
    components:{
        [JobHistoryTable.name]:JobHistoryTable,
    },
    data(){
      return{
        isDownloading:false,

        jobGroupLog:null,
        isLoading:true,
      }
    },
    created(){
      JobGroupLogRepository.getWithId(this.id).then((response) => {
        var data=response.data[0]
        this.jobGroupLog=data;
        this.isLoading=false;
      })
    },
    methods:{
      downloadResults(){
        this.isDownloading=true;
        LocationRepository.downloadJobGroupResults(this.id).then((response) => {
          this.downloadExcelBlob(response,'job_group_'+this.id+'.xlsx');
          this.isDownloading=false;
        });
      }
    }
}
</script>

<style>

</style>